var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_620)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_423_620)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 100 16h6.94l-.47-2.394a1.2 1.2 0 01.114-.788c.144-.275.627-1.217.816-1.768.242-.704.6-2.025.6-3.05a8 8 0 00-8-8zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 1.362-.446 2.935-.708 3.7-.196.57-.588 1.366-.806 1.794l.605 3.075A1.2 1.2 0 0119.913 22H12C6.477 22 2 17.523 2 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.998 12A1 1 0 117 12a1 1 0 011.998 0zm4 0A1 1 0 1111 12a1 1 0 011.998 0zm4 0A1 1 0 1115 12a1 1 0 011.998 0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_620"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_423_620"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconBlack);
export default __webpack_public_path__ + "static/media/chat-icon-black.ba3c7175d67ae8105c3ef43f126e3fda.svg";
export { ForwardRef as ReactComponent };